var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.hasData)?_c('categorical-insight-container',{attrs:{"columns":1}},[_c('chart',{staticStyle:{"height":"100%","position":"relative"},attrs:{"options":_vm.chartOptions}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }